import { render, staticRenderFns } from "./Works.vue?vue&type=template&id=c6d6139e&scoped=true&"
import script from "./Works.vue?vue&type=script&lang=ts&"
export * from "./Works.vue?vue&type=script&lang=ts&"
import style0 from "./Works.vue?vue&type=style&index=0&id=c6d6139e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6d6139e",
  null
  
)

export default component.exports